export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_so_purchaseOrderId') || '订单号',
    field: 'purchaseOrderId',
    width: 140,
    align: 'left',
  },
  {
    title: that.$l('table_label_so_customerOrderId') || '客户订单号',
    field: 'customerOrderId',
    minWidth: 140,
    align: 'left',
  },
  {
    title: that.$l('table_label_so_orderDateFormat') || '订单时间',
    field: 'orderDateFormat',
    minWidth: 140,
    align: 'left',
  },
  {
    title: that.$l('table_label_so_name') || '联系人',
    field: 'name',
    minWidth: 170,
    align: 'left',
  },
  {
    title: that.$l('table_label_so_phone') || '联系人手机号',
    field: 'phone',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
  },
  {
    title: that.$l('table_label_so_address1') || '收货地址1',
    field: 'address1',
    minWidth: 170,
    align: 'left',
  },
  {
    title: that.$l('table_label_so_address2') || '收货地址2',
    field: 'address2',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
  },
  {
    title: that.$l('table_label_so_city') || '收货城市',
    field: 'city',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
  },
  {
    title: that.$l('table_label_so_country') || '收货国家/地区',
    field: 'country',
    headerAlign: 'center',
    align: 'left',
    minWidth: 110,
  },
  {
    title: that.$l('table_label_so_state') || '收货省/州/府',
    field: 'state',
    headerAlign: 'center',
    align: 'left',
    minWidth: 110,
  },
  {
    title: that.$l('table_label_so_postalCode') || '邮编',
    field: 'postalCode',
    headerAlign: 'center',
    align: 'left',
    minWidth: 80,
  },
  {
    title: that.$l('table_label_so_status') || '订单状态',
    field: 'status',
    headerAlign: 'center',
    align: 'left',
    minWidth: 90,
  },
  {
    title: that.$l('table_label_so_trackingNumber') || '跟踪号',
    field: 'trackingNumber',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
  }
]
